import React from 'react';
import {View} from 'react-native';
import {get, isEmpty} from 'lodash';

import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './CoachSearchContent.style';
interface CoachSearchContentProps {
  recordData: Record<string, any>;
}

export const CoachSearchContent: React.FC<CoachSearchContentProps> = ({
  recordData = {},
}) => {
  const activatedOn = get(recordData, 'activatedOn', '');
  const qualifyingPoints = get(recordData, 'qualifyingPoints', '');
  const orderingEntitiesCount = get(recordData, 'orderingEntitiesCount', 0);
  const highestAchievedRank = get(recordData, 'highestAchievedRank', {});
  const highestAchievedRankName = get(highestAchievedRank, 'description', {});
  const businessCoach = get(recordData, 'businessCoach', {});
  const firstName = get(businessCoach, 'firstName', {});
  const lastName = get(businessCoach, 'lastName', {});

  const {tt} = useTranslation('reportCardContent.allSearchCoaches');

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">
            {tt('title', 'All Organization Coaches')}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('activationDate', 'Activation Date')}</Text>}
          suffix={
            <Text variant="button">{`${getDateUtilDefaultInstance().formatDate(
              activatedOn,
              'MMMM d, yyyy',
            )}`}</Text>
          }
          testID={CoachInfoCard.activationDateContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('businessCoach', 'Business Coach')}</Text>}
          suffix={<Text variant="button">{`${firstName} ${lastName}`}</Text>}
          testID={CoachInfoCard.businessCoachContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={
            <Text>{tt('highestRankAchieved', 'Highest Rank Achieved')}</Text>
          }
          suffix={
            <Text variant="button">
              {isEmpty(highestAchievedRankName)
                ? tt('notAvailable', 'N/A')
                : highestAchievedRankName}
            </Text>
          }
          testID={CoachInfoCard.harContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('orderingEntities', 'Ordering Entities')}</Text>}
          suffix={<Text variant="button">{orderingEntitiesCount}</Text>}
          testID={CoachInfoCard.oeContent}
        />
      </Gutter>
      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly={true}
          label={<Text>{tt('qualifyingPoints', 'Qualifying Points')}</Text>}
          suffix={<Text variant="button">{qualifyingPoints}</Text>}
          testID={CoachInfoCard.qualifyingPointsContent}
        />
      </Gutter>
    </View>
  );
};
